module.exports = __webpack_public_path__ + "949eb307.png";